export default function transformIndexToWorld(imageData, voxelPos) {
    return imageData.indexToWorld(voxelPos);
}
